import { styled } from "@mui/material/styles"
import { ToggleButton } from "@mui/material"

export const SbToggleButton = styled(ToggleButton)(({theme}) => ({
	"&.MuiToggleButton-root": {
		fontSize: "0.75em",
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 40,
		paddingRight: 40,
		textTransform: "none",
		backgroundColor: "#0773b7",
		color: "#FFFFFF",
	},
	"&.Mui-selected, &.Mui-selected:hover": {
		color: "white",
		backgroundColor: theme.palette.secondary.main
	}
}))
